module.exports = __webpack_public_path__ + "img/16_fineStaff_lzz.ca5c7efc.png";